/* eslint-disable react/jsx-pascal-case */
import { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import api from "../../../../Component/axios_Interceptor/api";
import url from "../../../../Component/server";
import { Icon, RowView } from "../../../../Component/style/common_style";
import { amountFormat } from "../../../../Component/tool/Tools";
import SearchAddrApi from "../../Sign/Modal/SearchAddrApi";

interface Del_Info_Modal_Props {
  visible: boolean;
  handleModal: React.Dispatch<React.SetStateAction<boolean>>;
  seq: number;
}
interface SaveBtnProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  disabled?: boolean; // optional로 설정
}

const slideUp = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;
const slideDown = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(100%);
    opacity: 0;
  }
`;
const BackgroundArea = styled.div<{ $visible: boolean; $isOpen: boolean }>`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background-color: #00000085;
  position: absolute;
  display: ${(props) => (props.$visible ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  transition: opacity 0.5s ease;
  opacity: ${(props) => (props.$isOpen ? 1 : 0)};
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  z-index: 99;
`;
const ModalBox = styled.div<{ $isOpen: boolean }>`
  box-sizing: border-box;
  width: 100%;
  max-width: 500px;
  max-height: 95%;
  background-color: white;
  color: #454545;
  border-top-right-radius: 16px;
  border-top-left-radius: 16px;
  overflow: hidden;
  position: absolute;
  bottom: 0px;
  animation: ${(props) => (props.$isOpen ? slideUp : slideDown)} 0.5s ease;
  overflow-y: auto;
  scrollbar-width: thin;
  color: #1d1d1d;
`;
const Title_Box = styled.div`
  width: 100%;
  height: 70px;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-family: var(--font-Pretendard-Bold);
`;
const Exit_Btn = styled(Icon)`
  position: absolute;
  right: 30px;
  justify-self: flex-end;
  cursor: pointer;
`;
const Content_Box = styled.div`
  width: 100%;
  padding: 0px 16px;
  display: flex;
  position: relative;
  align-items: flex-start;
  box-sizing: border-box;
  flex-direction: column;
  font-size: 16px;
`;

const Notice_Box = styled.div`
  width: 100%;
  padding: 22px 16px;
  border-radius: 8px;
  border-width: 1px;
  border-color: #f0f0f0;
  border-style: solid;
  background-color: #fbfbfb;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  line-height: 22px;
  box-sizing: border-box;

  div.bold {
    font-family: var(--font-Pretendard-Bold);
  }
  div.red {
    color: #ea2922;
  }
`;
const Insert_Box = styled.div`
  margin-top: 24px;
  width: 100%;
  font-family: var(--font-Pretendard-Medium);
`;
const Insert_Input = styled.input`
  border-radius: 8px;
  border-style: solid;
  border-width: 2px;
  border-color: #f0f0f0;
  margin-top: 6px;
  width: 100%;
  height: 44px;
  box-sizing: border-box;
  padding-left: 16px;
  font-size: 16px;
  display: flex;
  text-justify: center;
  outline: 0;
`;

const Address_Btn = styled.div`
  background-color: #2d2d2d;
  border-radius: 8px;
  height: 44px;
  width: 76px;
  color: white;
  align-items: center;
  justify-content: center;
  display: flex;
  justify-self: center;
  margin-left: 8px;
  cursor: pointer;
`;
const Buy_List_Box = styled.div`
  border-radius: 8px;
  border-width: 1px;
  border-color: #f8f8f8;
  border-style: solid;
  width: 100%;
  margin-top: 40px;
  margin-bottom: 20px;
`;
const Buy_List_Title_Box = styled.div`
  width: 100%;
  padding: 24px;
  background-color: #fbfbfb;
  font-size: 20px;
  font-family: var(--font-Pretendard-Bold);
  box-sizing: border-box;
`;
const Buy_List = styled.div`
  box-sizing: border-box;
  margin: 24px;
  font-family: var(--font-Pretendard-Medium);
  div.num {
    line-height: 20px;
  }
  div.item {
    margin-bottom: 10px;
  }
  div.count {
    color: #8e8e8e;
    flex-direction: row;
    justify-content: space-between;
    display: flex;
    align-items: center;
    div.price {
      font-size: 20px;
      font-family: var(--font-Pretendard-Bold);
      color: #2b2b2b;
    }
  }
`;
const Underline = styled.div`
  width: 100%;
  padding-top: 28px;
  border-width: 0px 0px 1px 0px;
  border-color: #d9d9d9;
  border-style: solid;
`;
const Total_Box = styled.div`
  border-width: 2px 0px 0px 0px;
  border-style: solid;
  border-color: #2d2d2d;
  padding: 20px 0px;
  width: 100%;
  justify-content: space-between;
  display: flex;
  font-family: var(--font-Pretendard-Medium);
  align-items: center;
  div.total_price {
    font-family: var(--font-Pretendard-Bold);
    font-size: 24px;
    color: #ea2922;
  }
`;
const Save_Btn = styled.div<SaveBtnProps>`
  border-width: 0px;
  display: flex;
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 74px;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background-color: ${(props) => (props.disabled ? "#f8f8f8" : "transparent")};
  background-image: ${(props) =>
    props.disabled ? "none" : "linear-gradient(135deg, #7955F0, #3209B9)"};
  color: ${(props) => (props.disabled ? "#8e8e8e" : "white")};
  font-size: 20px;
  font-family: var(--font-Pretendard-SemiBold);
  cursor: pointer;
  &:disabled {
    cursor: not-allowed;
  }
`;
const Empty_Box = styled.div`
  height: 200px;
  width: 100%;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  display: flex;
  margin-bottom: 50px;
`;

const Cancel_Btn = styled.div`
  width: 72px;
  height: 28px;
  border-radius: 4px;
  border-width: 1px;
  border-color: #d9d9d9;
  border-style: solid;
  align-items: center;
  justify-content: center;
  display: flex;
  color: #8e8e8e;
  justify-self: flex-end;
  margin-top: 16px;
  cursor: pointer;
`;

type user_data_type = {
  seq: number;
  order_nickname: string;
  order_name: string;
  addr_recipient: string;
  addr_phone: string;
  addr_num: string;
  addr_basic: string;
  addr_detail: string;
};
type buy_list_type = {
  product_num: number;
  product_name: string;
  option_name: string;
  order_cnt: number;
  order_price: number;
  seq: number;
}[];

const Delivery_Info_Modal = (props: Del_Info_Modal_Props) => {
  const { visible, handleModal } = props;
  const [user_data, set_User_Data] = useState<user_data_type>({
    seq: 0,
    order_nickname: "",
    order_name: "",
    addr_recipient: "",
    addr_phone: "",
    addr_num: "",
    addr_basic: "",
    addr_detail: "",
  });

  const [nickname, set_Nickname] = useState("");
  const [name, set_Name] = useState("");
  const [recipient, set_Recipient] = useState("");
  const [phone, set_Phone] = useState("");
  const [postCode, setPostCode] = useState("");
  const [firAddr, setFirAddr] = useState("");
  const [secAddr, setSecAddr] = useState("");

  const [buy_list, set_Buy_List] = useState<buy_list_type>([]);
  const [total_price, set_Total_Price] = useState(0);

  const closeModal = () => handleModal(false);

  const openSearchAddr = () =>
    SearchAddrApi({ setFirAddr, setPostCode, setDetail: setSecAddr });
  const recipient_Change = (e: React.ChangeEvent<HTMLInputElement>) =>
    set_Recipient(e.target.value);
  const phone_Change = (e: React.ChangeEvent<HTMLInputElement>) =>
    set_Phone(e.target.value);
  const detail_address_Change = (e: React.ChangeEvent<HTMLInputElement>) =>
    setSecAddr(e.target.value);

  const async_function = async () => {
    try {
      const res = await api.get(url.Communication_url.order_info, {
        params: { live_seq: props.seq },
      });

      if (res.data !== "") {
        res && set_Nickname(res.data.order.order_nickname);
        res && set_Name(res.data.order.order_name);
        res && set_Recipient(res.data.order.addr_recipient);
        res && set_Phone(res.data.order.addr_phone);
        res && setPostCode(res.data.order.addr_num);
        res && setFirAddr(res.data.order.addr_basic);
        res && setSecAddr(res.data.order.addr_detail);
        res && set_Total_Price(res.data.order.total_payment);
        res && set_User_Data(res.data.order);
        res && set_Buy_List(res.data.order_detail);
      }
    } catch (err) {
      console.log("실패: ", err);
    }
  };
  useEffect(() => {
    if (visible) {
      handleModal(true);
      async_function();
    } else {
      setTimeout(() => {
        handleModal(false);
      }, 500);
    }
  }, [visible]);

  const user_data_save = async () => {
    if (
      recipient === "" ||
      phone === "" ||
      postCode === "" ||
      firAddr === "" ||
      secAddr === ""
    ) {
      alert("빈 칸을 채워주세요.");
      return;
    }

    try {
      const res = await api.patch(url.Communication_url.order_address_update, {
        seq: user_data.seq,
        addr_recipient: recipient,
        addr_phone: phone,
        addr_num: postCode,
        addr_basic: firAddr,
        addr_detail: secAddr,
      });

      res.data === "성공" ? async_function() : alert("실패");
    } catch (err) {
      console.log(err);
    }
  };

  // const user_order_cancle = async (seq: number) => {
  //   try {
  //     const res = await api.patch(url.Communication_url.user_order_cancle, {
  //       seq: seq,
  //       order_status: "주문취소",
  //     });

  //     res.data === "성공" ? async_function() : alert("실패");
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  // const cancel_confirm = (product_num: number) => {
  //   const confirm = window.confirm("취소하시겠습니까?");
  //   if (confirm) {
  //     user_order_cancle(product_num);
  //   } else {
  //     return;
  //   }
  // };

  return (
    <BackgroundArea $visible={visible} $isOpen={visible} translate="no">
      <ModalBox $isOpen={visible} onClick={(e: any) => e.stopPropagation()}>
        <Title_Box>
          <div>배송정보</div>
          <Exit_Btn
            src={require("../../../../Image/ic_closeX.png")}
            onClick={closeModal}
          />
        </Title_Box>
        <Content_Box>
          {buy_list.length > 0 ? (
            <>
              <Notice_Box>
                <div className="bold">
                  *배송정보 변경은 고객센터로 연락주세요.
                </div>
                <div className="red">(오배송 사고 방지)</div>
              </Notice_Box>
              <Insert_Box>
                닉네임(입금자명)
                <Insert_Input
                  name="nickname"
                  value={nickname}
                  disabled
                  readOnly
                />
              </Insert_Box>
              {/* <Insert_Box>
                입금자명
                <Insert_Input name="name" value={name} disabled readOnly />
              </Insert_Box> */}
              <Insert_Box>
                수령자명
                <Insert_Input
                  name="recipient"
                  value={recipient}
                  onChange={recipient_Change}
                />
              </Insert_Box>
              <Insert_Box>
                연락처
                <Insert_Input
                  name="phone"
                  value={phone}
                  onChange={phone_Change}
                  maxLength={13}
                />
              </Insert_Box>
              <Insert_Box>
                주소
                <RowView className="bottom">
                  <Insert_Input
                    name="zonecode"
                    value={postCode}
                    disabled
                    readOnly
                  />
                  <Address_Btn onClick={openSearchAddr}>검색</Address_Btn>
                </RowView>
                <Insert_Input
                  name="address"
                  value={firAddr}
                  disabled
                  readOnly
                />
                <Insert_Input
                  name="detailed_address"
                  value={secAddr}
                  onChange={detail_address_Change}
                />
              </Insert_Box>
              <Buy_List_Box>
                <Buy_List_Title_Box>구매목록</Buy_List_Title_Box>
                {buy_list &&
                  buy_list.map((item, index) => {
                    return (
                      <Buy_List key={index}>
                        {item.product_num !== null &&
                          item.product_num !== undefined && (
                            <div className="num" translate="no">
                              No.{item.product_num}
                            </div>
                          )}

                        <div className="item">
                          {item.product_name}
                          {item.option_name !== null ? " / " : ""}
                          {item.option_name}
                        </div>
                        <div className="count">
                          <div>수량: {item.order_cnt}개</div>
                          <div className="price">
                            {amountFormat(item.order_price)}원
                          </div>
                        </div>
                        {index !== buy_list.length - 1 && <Underline />}
                      </Buy_List>
                    );
                  })}
              </Buy_List_Box>
              <Total_Box>
                <div>총 구매금액</div>
                <div className="total_price">{amountFormat(total_price)}원</div>
              </Total_Box>
              <br />
              <br />
              <br />
              <br />
              <br />
            </>
          ) : (
            <Empty_Box>주문내역이 없습니다.</Empty_Box>
          )}
        </Content_Box>
      </ModalBox>
      {buy_list.length > 0 ? (
        <Save_Btn
          as="button"
          disabled={
            !(
              user_data?.addr_recipient !== recipient ||
              user_data?.addr_basic !== firAddr ||
              user_data?.addr_detail !== secAddr ||
              user_data.addr_phone !== phone
            )
          }
          onClick={user_data_save}
        >
          저장하기
        </Save_Btn>
      ) : (
        <></>
      )}
    </BackgroundArea>
  );
};

export default Delivery_Info_Modal;
